import React, { useContext, useEffect, useState } from 'react'
import './Footer.css'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { Button, Popover, ListItem } from '@material-ui/core'
import isAuthenticate from '../../../Utils/Utility/auth'
function Footer() {
    const [anchormenu, setanchormenu] = useState(null)
    const [display_submenu, setSubmenu] = useState(true)

    const state_loc = useSelector((state) => state.storeDetails)

    if (state_loc.storeDetails.nav_menu) {
        var nav_menu = state_loc.storeDetails.nav_menu
    } else {
        var nav_menu = []
    }
    if (nav_menu.length > 0) {
        var footer_menu = nav_menu.filter((val) => val.menu_type == 'footer')
    } else {
        var footer_menu = []
    }

    const handleMenu = (event) => {
        setanchormenu(event.currentTarget)
    }

    const handleClose = () => {
        setanchormenu(null)
    }

    return (
        <>
            <div className="footerCnt">
                <div className="hmcustomContainer d-flex align-items-start justify-content-between flex-wrap">
                    <div className="lftFtrLgnCntn">
                        <a href={'/'} className="footlogo">
                            {/* <img className="Logo" src="/images/Logo.png" alt="Starling Auctions" /> */}
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="80"
                                height="80"
                                fill="#fff"
                                viewBox="0 0 773.536 745.386"
                            >
                                <g
                                    id="Group_3"
                                    data-name="Group 3"
                                    transform="translate(1564.344 -1843.822)"
                                >
                                    <g
                                        id="Group_2"
                                        data-name="Group 2"
                                        transform="translate(-1191 383.273)"
                                    >
                                        <g id="Group_1" data-name="Group 1">
                                            <path
                                                id="Path_1"
                                                data-name="Path 1"
                                                d="M570.825,220.479l94.211,63.134-16.029,21.263-8.505-1.963-5.561,7.851L470.726,198.889l5.234-5.561-5.234-8.505,16.029-21.59Z"
                                                transform="matrix(1, -0.017, 0.017, 1, -597.597, 1308.947)"
                                            />
                                            <path
                                                id="Path_3"
                                                data-name="Path 3"
                                                d="M566.752,255.258l-96.026-64.351,16.338-21.673,8.669,2,5.668-8L668.78,277.264l-5.335,5.668,5.335,8.669-16.338,22.006Z"
                                                transform="translate(-777.747 1563.531)"
                                            />
                                            <path
                                                id="Path_2"
                                                data-name="Path 2"
                                                d="M465.656,206.675l-41.25,63.363H410.8l-42.526,68.892v12.758l-45.077,68.892L488.62,531.145l46.353-70.167,10.631,6.379,10.206-14.033L900,683.806l12.146-13.36,8.5,6.073-1.44,7.287,2.768,6.922,1.258,4.026,3.02,3.774,3.271,1.007,5.284,3.774h15.853l4.781-2.516,4.278-2.265,4.026-3.774,3.271-5.033,1.51-4.781,1.761-5.787,1.258-8.707-4.529-8.656-9.059-6.291-6.291-4.026h-8.807l-8.052,1.258-2.265,2.768-6.291-4.026,12.33-17.866-23.758-15.661L587.109,401.91l9.951-13.821-9.951-7.74,44.779-65.787Z"
                                                transform="translate(-593.547 1301)"
                                            />
                                            <rect
                                                id="Rectangle_1"
                                                data-name="Rectangle 1"
                                                width="342"
                                                height="49"
                                                rx="4"
                                                transform="translate(-350.547 1955)"
                                            />
                                            <rect
                                                id="Rectangle_2"
                                                data-name="Rectangle 2"
                                                width="342"
                                                height="36"
                                                rx="4"
                                                transform="translate(-350.547 1915)"
                                            />
                                            <rect
                                                id="Rectangle_3"
                                                data-name="Rectangle 3"
                                                width="342"
                                                height="20"
                                                rx="4"
                                                transform="translate(-350.547 1891)"
                                            />
                                        </g>
                                    </g>
                                    <path
                                        id="Path_4"
                                        data-name="Path 4"
                                        d="M119.416,0,70.1-122.728H51.152L1.656,0h17.48L29.992-27.416H91.08L101.936,0ZM86.664-40.848H34.592l25.944-66.24ZM180.688,2.208c33.3,0,50.232-19.5,50.232-50.048v-74.888H215.464v74.7c0,22.448-12.144,36.616-34.776,36.616S146.1-25.576,146.1-48.024v-74.7H130.64v75.072C130.64-17.48,147.568,2.208,180.688,2.208Zm137.08,0c21.712,0,36.432-10.3,46.736-24.472l-12.88-6.992a41.748,41.748,0,0,1-33.856,17.848c-26.864,0-47.288-20.792-47.288-49.864,0-29.44,20.424-49.864,47.288-49.864a41.27,41.27,0,0,1,33.856,17.848l12.7-7.176c-9.752-13.984-24.84-24.288-46.552-24.288-35.328,0-63.112,25.76-63.112,63.48S282.44,2.208,317.768,2.208ZM429.64,0V-109.112h39.008v-13.616h-93.1v13.616h38.824V0Zm74.52,0V-122.728H488.888V0ZM588.8,2.208c36.248,0,61.088-27.232,61.088-63.48s-24.84-63.48-61.088-63.48-60.9,27.232-60.9,63.48S552.552,2.208,588.8,2.208Zm0-13.616c-27.6,0-45.08-21.344-45.08-49.864,0-28.7,17.48-49.864,45.08-49.864,27.416,0,45.264,21.16,45.264,49.864C634.064-32.752,616.216-11.408,588.8-11.408ZM775.192,0V-122.728H759.92v95.864l-70.656-95.864h-15.64V0H688.9V-97.888L760.472,0Z"
                                        transform="translate(-1566 2587)"
                                    />
                                </g>
                            </svg>
                        </a>
                        {/* <p className="pgTgInfoLn">LICENSED | BONDED | INSURED</p> */}
                        <div className="scmlMdaLnks">
                            <div className="mdaWrpr fbLnk">
                                <a
                                    href="https://www.facebook.com/starlingauctions"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src="/images/fb_footer.svg" />
                                </a>
                            </div>
                            {/* <div className="mdaWrpr twLnk">
                                <a
                                    href="https://twitter.com/CoinsSince1994?ref_src=twsrc%5Egoogle%7Ctwcamp%5Eserp%7Ctwgr%5Eauthor"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    <img src="/images/twitter_footer.svg" />
                                </a>
                            </div> */}
                        </div>
                    </div>
                    <div className="rtCntIntoWrpr">
                        <div className="termWrp">
                            <ul>
                                {window.location.href != window.location.origin + '/' ? (
                                    <li>
                                        <Link to="/">Home</Link>
                                    </li>
                                ) : (
                                    ''
                                )}
                                <li>
                                    <Link to="/contactus">Contact Us</Link>
                                </li>

                                <>
                                    {footer_menu ? (
                                        <>
                                            {footer_menu.length > 0
                                                ? footer_menu.map((val) =>
                                                      val.subLinks.length > 0 ? (
                                                          <li>
                                                              <div className="nav-menu-from-store">
                                                                  <a
                                                                      //   target={'_blank'}
                                                                      //   rel="noreferrer"
                                                                      className="active"
                                                                      href={val.path}
                                                                  >
                                                                      {val.label}
                                                                  </a>

                                                                  <Button
                                                                      aria-controls="simple-menu"
                                                                      aria-haspopup="true"
                                                                      onClick={handleMenu}
                                                                  >
                                                                      {!Boolean(anchormenu) ? (
                                                                          <span className="material-icons-outlined">
                                                                              expand_more
                                                                          </span>
                                                                      ) : (
                                                                          <span className="material-icons-outlined">
                                                                              expand_less
                                                                          </span>
                                                                      )}
                                                                  </Button>
                                                              </div>
                                                              <Popover
                                                                  id={'simple-menu'}
                                                                  open={Boolean(anchormenu)}
                                                                  anchorEl={anchormenu}
                                                                  onClose={handleClose}
                                                                  anchorOrigin={{
                                                                      vertical: 'bottom',
                                                                      horizontal: 'right',
                                                                  }}
                                                                  transformOrigin={{
                                                                      vertical: 'top',
                                                                      horizontal: 'right',
                                                                  }}
                                                              >
                                                                  <ul className="headerDropMenu">
                                                                      {val.subLinks.map((data) => (
                                                                          <a
                                                                              rel="noreferrer"
                                                                              //target={'_blank'}
                                                                              //className="active"
                                                                              href={data.path}
                                                                          >
                                                                              <ListItem>
                                                                                  {data.label}
                                                                              </ListItem>
                                                                          </a>
                                                                      ))}
                                                                  </ul>
                                                              </Popover>
                                                          </li>
                                                      ) : (
                                                          <li>
                                                              <a
                                                                  //   target={'_blank'}
                                                                  //   rel="noreferrer"
                                                                  className="active"
                                                                  href={val.path}
                                                              >
                                                                  {val.label}
                                                              </a>
                                                          </li>
                                                      ),
                                                  )
                                                : ''}
                                        </>
                                    ) : (
                                        ''
                                    )}
                                </>
                                {/* <li>
                                    <Link to="/aboutus">About Us</Link>
                                </li> */}
                            </ul>
                            {/* <div className="mlInfoTxt text-left">
                                <a href="mailto:starlingauctionsclaresholm@outlook.com">
                                    starlingauctionsclaresholm@outlook.com
                                </a>
                            </div> */}
                        </div>
                        <div className="adrsInfoWrpr text-left">
                            <p className="stnTtle">FIND US HERE</p>
                            {/* <div className="flxGrdVwRp">
                                <img src="/images/footer_user.svg" />
                                <div className="rtCrsTxt">
                                    <p>Ken & Takumi</p>
                                </div>
                            </div> */}
                            <div className="flxGrdVwRp">
                                <img src="/images/footer_company.svg" />
                                <div className="rtCrsTxt">
                                    <p>No.21 Auction Company</p>
                                </div>
                            </div>
                            <div className="flxGrdVwRp">
                                <img src="/images/footer_location.svg" />
                                <div className="rtCrsTxt">
                                    <p>
                                        5521 2nd Street East
                                        <br />
                                        Claresholm, Alberta{' '}
                                    </p>
                                </div>
                            </div>
                            <div className="flxGrdVwRp">
                                <img src="/images/footer_phone.svg" />
                                <div className="rtCrsTxt">
                                    <p>
                                        Call us: <a href="tel:4036250274">(403)625-0274</a>
                                    </p>
                                    {/* <p>
                                        Text: <a href="tel:3602815588">(360) 281-5588</a>
                                    </p>
                                    <p>
                                        Local: <a href="tel:3602535565">(360) 253-5565</a>
                                    </p> */}
                                </div>
                            </div>
                            <div className="flxGrdVwRp">
                                <img src="/images/footer_mail.svg" />
                                <div className="rtCrsTxt">
                                    <a
                                        href="mailto:starlingauctionsclaresholm@outlook.com"
                                        style={{ wordBreak: 'break-all' }}
                                    >
                                        starlingauctionsclaresholm@outlook.com
                                    </a>
                                    {/* <p>
                                        Text: <a href="tel:3602815588">(360) 281-5588</a>
                                    </p>
                                    <p>
                                        Local: <a href="tel:3602535565">(360) 253-5565</a>
                                    </p> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={isAuthenticate() != null ? 'cpyRtFtr pb-76' : 'cpyRtFtr'}>
                <p>
                    ©{new Date().getFullYear()} No.21 Auction Company |{' '}
                    <Link to="/TermsandConditions">Terms & Conditions</Link>
                </p>
            </div>
        </>
    )
}

export default Footer
